var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-content mt-6 ml-3 mr-3"},[_c('div',{staticClass:"theme-bg theme-c-white line"},[_vm._t("top")],2),_c('div',{staticClass:"p-2"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }